<template>
  <div id="myDivCalen" class="container-aqi imgbg">
    <div style="widht: 100%; display: flex; align-items: center" class="grid-header bg-light">
      <div style="width: 20%">
        <img class="yamaha-top-left" src="@/assets/images/yamahaaqi/Logo_Yamaha_White-01-removebg-preview.png" />
      </div>
      <div style="width: 60%">
        <ul align="center" id="h-title-dash" style="list-style: none; margin-bottom: 0">
          <li>
            <h3 style="font-weight: 600" class="textHeader">
              Ambient Air Quality Monitoring
            </h3>
          </li>
          <li class="mt-2">
            <h5 style="font-weight: 600" class="textHeaderth thFontthai">
              การรายงานผลการตรวจวัดคุณภาพอากาศ
            </h5>
          </li>
        </ul>
      </div>
      <div style="width: 20%">
        <div style="display: flex; justify-content: flex-end">
          <h3>{{currentTime}}</h3>
          <vs-button radius style="font-weight: 600" type="flat" color="dark" v-if="showIcon" to="/aqidashboardgraph">
            <span style="font-weight: 600" class="material-icons">
              query_stats
            </span></vs-button>
          <vs-button radius style="font-weight: 600" type="flat" color="dark" v-if="showIcon"
            @click="hideSideBar('myDivCalen')">
            <span style="font-weight: 600" class="material-icons">
              zoom_out_map
            </span></vs-button>
          <vs-button radius type="flat" color="dark" v-else @click="showSideBar">
            <span style="font-weight: 600" class="material-icons">
              zoom_in_map
            </span></vs-button>
        </div>
      </div>
    </div>

    <div class="grid-map">
      <div style="position: relative; height: 100%" class="carddiv">
        <mapsensor v-if="result_value != undefined" :result_value="result_value" />
        <div class="chartwindrose">
          <HWindroseChart :chart="dataChartWindRose_2" />
        </div>
        <ul style="list-style: none" class="list-map-div">
          <li id="lv_Air_Quality" class="thFontthai text_size">
            เกณฑ์ทิศทางและ
            <br />ความเร็วลม
          </li>
          <li v-for="i in labeltext" :key="i">
            <vs-icon size="16px" class="mr-2" :color="i.color" icon="fiber_manual_record"></vs-icon><a>{{ i.text }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="grid-aqi-quality">
      <div class="item-aqi-quality">
        <aqidiv style="height: 100%" :imglist="imglist_aqi" v-if="result_value != undefined"
          :value="result_value.aqi" />
      </div>
      <div class="item-aqi-level carddiv">
        <lv1 />
      </div>
    </div>
    <div class="grid-realtime">
      <div class="item-header-realtime">
        <div align="center" style="height: 100%" class="carddiv text-center">
          <ul style="
              list-style: none;
              display: flex;
              height: 100%;
              margin-bottom: 0px;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            ">
            <li>
              <h3 class="textHeader" style="font-weight: 600">
                Real Time Weather Conditions
              </h3>
            </li>
            <li>
              <h5 class="textHeaderth thFontthai" style="font-weight: 600">
                ข้อมูลภาพภูมิอากาศ
              </h5>
            </li>
          </ul>
        </div>
      </div>
      <div class="item-realtime-1">
        <weatherCond :imgGift1="
          require('@/assets/images/kubota/h gif/output-onlinegiftools (26).gif')
        " :unit="'°C'" :imglist="color_wa" :head="'Temperature'" v-if="result_value['air_polution'] != undefined"
          :value="Math.round(result_value['air_polution'].ambient_temp)" :detail="'อุณหภูมิ'" />
      </div>
      <div class="item-realtime-2">
        <weatherCond :imgGift1="
          require('@/assets/images/kubota/h gif/output-onlinegiftools (27).gif')
        " :unit="'%'" :imglist="color_wa" :head="'Relative Humidity'"
          v-if="result_value['air_polution'] != undefined" :value="Math.round(result_value['air_polution'].humidity)"
          :detail="'ความชื้น'" />
      </div>
      <div class="item-realtime-3">
        <weatherCond :imgGift1="
          require('@/assets/images/kubota/h gif/output-onlinegiftools (32).gif')
        " :unit="'m/s'" :imglist="color_wa" :head="'Wind Speed'" v-if="result_value['48FFFF661CD6'] != undefined"
          :value="result_value['48FFFF661CD6'].wind_speed" :detail="'ความเร็วลม'" />
      </div>
      <div class="item-realtime-4">
        <weatherCond :imgGift1="
          require('@/assets/images/kubota/h gif/output-onlinegiftools (30).gif')
        " :unit="wind_direction" :imglist="color_wa" :head="'Wind Direction'"
          v-if="result_value['48FFFF661CD6'] != undefined" :value="''" :detail="'ทิศทางลม'" />
      </div>
    </div>
    <div class="grid-airpollution">
      <div class="item-header-polution">
        <div align="center" style="height: 100%" class="carddiv text-center">
          <ul style="
              list-style: none;
              display: flex;
              height: 100%;
              margin-bottom: 0px;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            ">
            <li>
              <h3 class="textHeader" style="font-weight: 600">
                Real Time Air Pollution
              </h3>
            </li>
            <li>
              <h5 class="textHeaderth thFontthai" style="font-weight: 600">
                ข้อมูลมลพิษทางอากาศ
              </h5>
            </li>
          </ul>
        </div>
      </div>
      <div class="item-polu-level">
        <lv2 />
      </div>
      <div class="item-polu-1">
        <airpoluz v-if="result_value['air_polution'] != undefined"
          :imgGift1="require('@/assets/images/kubota/h gif/200-2.gif')" :imglist="imglist_pm25" :head="'PM2.5'"
          :value="result_value.air_polution.pm25" :detail="'ฝุ่นละอองขนาดไม่เกิน 2.5 ไมครอน'" />
      </div>
      <div class="item-polu-2">
        <airpoluz v-if="result_value['air_polution'] != undefined"
          :imgGift1="require('@/assets/images/kubota/h gif/bubbles.gif')" :imglist="imglist_pm10"
          :value="result_value.air_polution.pm10 / 1000" :head="'PM10'" :detail="'ฝุ่นละอองขนาดไม่เกิน 10 ไมครอน'" />
      </div>
      <div class="item-polu-3">
        <airpoluz v-if="result_value != undefined" :head="'TVOCs'" :value="result_value.avgTVCO" :imglist="imglist_tvoc"
          :detail="'สารอินทรีย์ระเหยง่ายรวม'" :imgGift1="require('@/assets/images/kubota/h gif/world.gif')" />
      </div>
    </div>
  </div>
</template>

<script>
import lv1 from "./components/level_aqi.vue";
import lv2 from "./components/level_AirPullution.vue";
import airpoluz from "./components/AirPullution.vue";
import weatherCond from "./components/WeatherConditions.vue";
import LineChart from "@/components/ChartJs/LineChart.vue";
import aqidiv from "./components/aqi.vue";
import mapsensor from "./map.vue";
import moment from "moment";
import HighchartsA from "highcharts";
import More from "highcharts/highcharts-more";
import HWindroseChart from "@/components/HighChart/WindroseChart.vue";
import HLineChart from "@/components/HighChart/LineChart.vue";
More(HighchartsA);
export default {
  components: {
    lv1,
    airpoluz,
    LineChart,
    mapsensor,
    weatherCond,
    aqidiv,
    lv2,
    HWindroseChart,
    HLineChart,
  },
  data() {
    return {
      delay: 0,
      chart_line_a: {
        chart: {
          height: 230,
          type: "line",
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [],
          tickmarkPlacement: "on",
          title: {
            enabled: false,
          },
        },
        yAxis: {
          title: {
            enabled: false,
          },
          labels: {
            formatter: function () {
              return this.value / 1000;
            },
          },
        },
        tooltip: {
          split: true,
          // valueSuffix: " millions",
        },
        plotOptions: {
          area: {
            stacking: "normal",
            lineColor: "#666666",
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: "#666666",
            },
          },
        },

        series: [
          {
            name: "PM 25",
            data: [],
          },
          {
            name: "PM 10",
            data: [],
          },
          {
            name: "TVOC 1",
            data: [],
          },
          {
            name: "TVOC 2",
            data: [],
          },
          {
            name: "TVOC 3",
            data: [],
          },
          {
            name: "TVOC 4",
            data: [],
          },
        ],
      },
      showIcon: true,
      wind_direction: "",
      dataChartWindRose: null,
      windRoseSeries: [],
      dataChartWindRose_2: {
        chart: {
          polar: true,
          type: "column",
          backgroundColor: "transparent",
          height: 120,
          width: 140,
        },
        title: {
          text: null,
          align: "left",
        },
        pane: {
          size: "80%",
        },

        legend: {
          enabled: false,
        },
        xAxis: {
          visible: true,
          tickmarkPlacement: "on",
          type: "category",
        },
        yAxis: {
          visible: false,
          min: 0,
          endOnTick: false,
          showLastLabel: true,
          title: {
            text: "Frequency (%)",
          },
          labels: {
            formatter: function () {
              return this.value + "%";
            },
          },
          reversedStacks: false,
        },
        tooltip: {
          valueSuffix: "%",
        },
        navigation: {
          buttonOptions: {
            enabled: false,
          },
        },
        colors: [
          "#00ffff",
          "#008000",
          "#0000ff",
          "#ff0000",
          "#ffff00",
          "#c0dcc0",
        ],
        plotOptions: {
          series: {
            stacking: "normal",
            shadow: false,
            groupPadding: 0,
            pointPlacement: "on",
          },
        }, credits: {
          enabled: false
        },
        series: [
          {
            data: [
              ["N", 0],
              ["NE", 0],
              ["E", 0],
              ["SE", 0],
              ["S", 0],
              ["SW", 0],
              ["W", 0],
              ["NW", 0],
            ],
            type: "column",
            name: "0.50 - 2.10",
          },
          {
            data: [
              ["N", 0],
              ["NE", 0],
              ["E", 0],
              ["SE", 0],
              ["S", 0],
              ["SW", 0],
              ["W", 0],
              ["NW", 0],
            ],
            type: "column",
            name: "2.10 - 3.60",
          },
          {
            data: [
              ["N", 0],
              ["NE", 0],
              ["E", 0],
              ["SE", 0],
              ["S", 0],
              ["SW", 0],
              ["W", 0],
              ["NW", 0],
            ],
            type: "column",
            name: "3.60 - 5.70",
          },
          {
            data: [
              ["N", 0],
              ["NE", 0],
              ["E", 0],
              ["SE", 0],
              ["S", 0],
              ["SW", 0],
              ["W", 0],
              ["NW", 0],
            ],
            type: "column",
            name: "5.70 - 8.80",
          },
          {
            data: [
              ["N", 0],
              ["NE", 0],
              ["E", 0],
              ["SE", 0],
              ["S", 0],
              ["SW", 0],
              ["W", 0],
              ["NW", 0],
            ],
            type: "column",
            name: "8.80 - 11.10",
          },
          {
            data: [
              ["N", 0],
              ["NE", 0],
              ["E", 0],
              ["SE", 0],
              ["S", 0],
              ["SW", 0],
              ["W", 0],
              ["NW", 0],
            ],
            type: "column",
            name: ">= 11.10",
          },
        ],
      },
      selectData: 1,
      labeltext: [
        // { text: "Temperature", color: "#7CB5EC" },
        // { text: "Humidity", color: "#434348" },
        // { text: "Wind Speed", color: "#90ED7D" },
        // { text: "Wind Direction", color: "#F7A35C" },
        // { text: "PM2.5", color: "#8085E9" },
        // { text: "PM10", color: "#F15C80" },
        // { text: "TVOC", color: "#E4D354" },
        { text: ">= 11.10", color: "#c0dcc0" },
        { text: "8.80 - 11.10", color: "#ffff00" },
        { text: "5.70 - 8.80", color: "#ff0000" },
        { text: "3.60 - 5.70", color: "#0000ff" },
        { text: "2.10 - 3.60", color: "#008000" },
        { text: "0.50 - 2.10", color: "#00ffff" },
      ],
      get_data: [],
      datacollection: {
        labels: [],
        datasets: [
          {
            label: "PM 2.5",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: [],
            borderWidth: 2,
            borderColor: "rgba(172, 0, 252,.9)",
          },
          {
            label: "PM 10",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: [],
            borderWidth: 2,
            borderColor: "rgba(231, 78, 82,.9)",
          },
          {
            label: "TVOC1",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: [],
            borderWidth: 2,
            borderColor: "rgba(107, 179, 106,.9)",
          },
          {
            label: "TVOC2",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: [],
            borderWidth: 2,
            borderColor: "rgba(0, 180, 230,.9)",
          },
          {
            label: "TVOC3",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: [],
            borderWidth: 2,
            borderColor: "rgba(230, 96, 188,.9)",
          },
          {
            label: "TVOC4",
            backgroundColor: "rgba(172, 0, 252,.0)",
            data: [],
            borderWidth: 2,
            borderColor: "rgba(241, 196, 15,.9)",
          },
          // {
          //   label: "TVOC5",
          //   backgroundColor: "rgba(172, 0, 252,.0)",
          //   data: [],
          //   borderWidth: 2,
          //   borderColor: "rgba(241, 196, 15,.9)",
          // },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
        },
      },
      interval: null,
      currentTime: "",
      imglist_pm25: {},
      imglist_pm10: {},
      imglist_tvoc: {},
      imglist_aqi: {},
      color_wa: {
        text: "Good",
        head: "rgba(98, 201, 147, 0.9)",
        cr: "#90E4B8",
        bg: "rgba(185, 226, 205, 0.9)",
        color: "#111111",
      },
      options1: [
        {
          text: "Daily",
          value: 1,
        },
        {
          text: "Monthly",
          value: 2,
        },
        {
          text: "Yearly",
          value: 3,
        },
      ],
      color_aqi: {
        lv1: {
          text: "Good",
          textth: "ดี",
          bg: "rgba(118, 210, 80, 0.9)",
          img: require("@/assets/images/aqi/aqi_lv1.png"),
          color: "#1b6106",
        },
        lv2: {
          text: "Moderate",
          textth: "ปานกลาง",
          img: require("@/assets/images/aqi/aqi_lv2.png"),
          bg: "rgba(201, 210, 80, 0.9)",
          color: "#5f6106",
        },
        lv3: {
          text: "Unhealthy",
          textth: "เริ่มมีผลต่อสุขภาพ",
          img: require("@/assets/images/aqi/aqi_lv3.png"),
          bg: "rgba(210, 158, 80, 0.9)",
          color: "#613706",
        },
        lv4: {
          text: "Literally Unhealthy",
          textth: "มีผลต่อสุขภาพมาก",
          bg: "rgba(210, 80, 80, 0.9)",
          img: require("@/assets/images/aqi/aqi_lv4.png"),
          color: "#610e06",
        },
        lv5: {
          text: "Very Unhealthy",
          textth: "มีผลต่อสุขภาพมาก",
          bg: "rgba(209, 73, 168, 0.9)",
          img: require("@/assets/images/aqi/aqi_lv5.png"),
          color: "#67174F",
        },
        lv6: {
          text: "Hazardous",
          textth: "อันตรายต่อสุขภาพ",
          bg: "rgba(224, 169, 76, 0.9)",
          img: require("@/assets/images/aqi/aqi_lv6.png"),
          color: "#745726",
        },
      },
      color_condi: {
        lv1: {
          text: "Excellent",
          head: "rgba(59, 204, 255, 0.9)",
          cr: "#93DEF5",
          bg: "rgba(223, 238, 240, 0.9)",
          color: "#3BCCFF",
        },
        lv2: {
          text: "Good",
          head: "rgba(98, 201, 147, 0.9)",
          cr: "#90E4B8",
          bg: "rgba(185, 226, 205, 0.9)",
          color: "#22600C",
        },
        lv3: {
          text: "Moderate",
          bg: "rgba(240, 240, 223, 0.9)",
          cr: "#F5F293",
          head: "rgba(255, 248, 54, 0.9)",
          color: "#AB960F",
        },
        lv4: {
          text: "Unhealthy",
          bg: "rgba(240, 231, 223, 0.9)",
          cr: "#F5C193",
          head: "rgba(255, 146, 54, 0.9)",
          color: "#BF7C2F",
        },
        lv5: {
          text: "Very Unhealthy",
          bg: "rgba(240, 223, 223, 0.9)",
          cr: "#F59393",
          head: "rgba(255, 54, 54, 0.9)",
          color: "#BF2F2F",
        },
      },
      timeout: null,
      result_value: [],
    };
  },
  methods: {
    showSideBar() {
      this.showIcon = true;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },
    hideSideBar(id) {
      var element = document.getElementById(id);
      this.showIcon = false;
      // Supports most browsers and their versions.
      var requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullScreen;

      if (requestMethod) {
        // Native full screen.
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== "undefined") {
        // Older IE.
        var wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    createChart() {
      HighchartsA.chart("chart-windrose", {
        chart: {
          polar: true,
          type: "column",
          backgroundColor: "transparent",
          height: 140,
          width: 150,
        },

        title: {
          text: null,
          align: "left",
        },

        // subtitle: {
        //   text: "Source: or.water.usgs.gov",
        //   align: "left",
        // },

        pane: {
          size: "85%",
        },

        legend: {
          enabled: false,
          // align: "right",
          // verticalAlign: "top",
          // layout: "vertical",
          // x: 0,
          // y: 30,
        },

        xAxis: {
          visible: true,
          tickmarkPlacement: "on",
          type: "category",
        },

        yAxis: {
          visible: false,
          min: 0,
          endOnTick: false,
          showLastLabel: true,
          title: {
            text: "Frequency (%)",
          },
          labels: {
            formatter: function () {
              return this.value + "%";
            },
          },
          reversedStacks: false,
        },

        tooltip: {
          valueSuffix: "%",
        },

        colors: [
          "#00ffff",
          "#008000",
          "#0000ff",
          "#ff0000",
          "#ffff00",
          "#c0dcc0",
        ],
        plotOptions: {
          series: {
            stacking: "normal",
            shadow: false,
            groupPadding: 0,
            pointPlacement: "on",
          },
        },
        // series: this.result_value.graph.WindRose,
        series: this.dataChartWindRose_2,
      });
    },
    selectDataGraph(item) {
      console.log(item);
      let data = [];
      let data_pm25 = [];
      let data_pm10 = [];
      let data_tvoc1 = [];
      let data_tvoc2 = [];
      let data_tvoc3 = [];
      let data_tvoc4 = [];
      let data_tvoc5 = [];
      let labels = [];

      // 48FFFF661CD6: (...)
      // 48FFFF661994: (...)
      // 48FFFF662208: (...)
      // datasets.reverse()
      // for (let i = datasets.length - 1; i >= 0; i--) {
      //   const el = datasets[i];
      //   data.push(el.volume);
      //   if (this.select1 == "day") {
      //     labels.push(el.time.split(" ")[1]);
      //   } else if (this.select1 == "month") {
      //     labels.push(el.time.split(" ")[0]);
      //   } else {
      //     labels.push(el.time);
      //   }
      // }
      if (item == 1) {
        if (!this.result_value.graph.day) return
        this.result_value.graph.day.forEach((element) => {
          // console.log(element.data.air_polution.pm10);
          if (element.data.air_polution != undefined) {
            data_pm10.push(element.data.air_polution.pm10);
            data_pm25.push(parseFloat(element.data.air_polution.pm25));
            data_tvoc1.push(parseFloat(element.data["48FFFF661CAB"]));
            data_tvoc2.push(parseFloat(element.data["48FFFF661994"]));
            data_tvoc3.push(parseFloat(element.data["48FFFF662208"]));
            data_tvoc4.push(parseFloat(element.data["48FFFF661AD3"]));
            // data_tvoc5.push(parseFloat(element.data.air_polution["48FFFF661CD6"]));
            labels.push(element.timestamp);
          } else {
            data_tvoc1.push(parseFloat(element.data["48FFFF661CAB"]));
            data_tvoc2.push(parseFloat(element.data["48FFFF661994"]));
            data_tvoc3.push(parseFloat(element.data["48FFFF662208"]));
            data_tvoc4.push(parseFloat(element.data["48FFFF661AD3"]));
            // data_tvoc5.push(parseFloat(element.data.air_polution["48FFFF661CD6"]));
            labels.push(element.timestamp);
          }
        });
      } else if (item == 2) {
        if (!this.result_value.graph.month) return
        this.result_value.graph.month.forEach((element) => {
          // console.log(element.data.air_polution.pm10);
          if (element.data.air_polution != undefined) {
            data_pm10.push(element.data.air_polution.pm10);
            data_pm25.push(parseFloat(element.data.air_polution.pm25));
            data_tvoc1.push(parseFloat(element.data["48FFFF661CAB"]));
            data_tvoc2.push(parseFloat(element.data["48FFFF661994"]));
            data_tvoc3.push(parseFloat(element.data["48FFFF662208"]));
            data_tvoc4.push(parseFloat(element.data["48FFFF661AD3"]));
            labels.push(element.timestamp);
          }
        });
      } else if (item == 3) {
        this.result_value.graph.year.forEach((element) => {
          if (!this.result_value.graph.year) return
          // console.log(element.data.air_polution.pm10);
          if (element.data.air_polution != undefined) {
            data_pm10.push(element.data.air_polution.pm10);
            data_pm25.push(parseFloat(element.data.air_polution.pm25));
            data_tvoc1.push(parseFloat(element.data["48FFFF661CAB"]));
            data_tvoc2.push(parseFloat(element.data["48FFFF661994"]));
            data_tvoc3.push(parseFloat(element.data["48FFFF662208"]));
            data_tvoc4.push(parseFloat(element.data["48FFFF661AD3"]));
            labels.push(element.timestamp);
          }
        });
      }
      // console.log(data_pm25);

      this.chart_line_a.xAxis.categories = labels;
      this.chart_line_a.series[0].data = data_pm25;
      this.chart_line_a.series[1].data = data_pm10;
      this.chart_line_a.series[2].data = data_tvoc1;
      this.chart_line_a.series[3].data = data_tvoc2;
      this.chart_line_a.series[4].data = data_tvoc3;
      this.chart_line_a.series[5].data = data_tvoc4;
    },
    check_lvpm10(item) {
      if (parseFloat(item) > 0.12) {
        this.imglist_pm10 = this.color_condi.lv5;
      } else if (parseFloat(item) <= 0.12) {
        this.imglist_pm10 = this.color_condi.lv2;
      }

      // if (parseFloat(item) > 180) {
      //   this.imglist_pm10 = this.color_condi.lv5;
      // } else if (parseFloat(item) <= 180 && parseFloat(item) > 120) {
      //   this.imglist_pm10 = this.color_condi.lv4;
      // } else if (parseFloat(item) <= 120 && parseFloat(item) > 80) {
      //   this.imglist_pm10 = this.color_condi.lv3;
      // } else if (parseFloat(item) <= 80 && parseFloat(item) > 50) {
      //   this.imglist_pm10 = this.color_condi.lv2;
      // } else if (parseFloat(item) <= 50) {
      //   this.imglist_pm10 = this.color_condi.lv1;
      // }
    },
    check_lvpm25(item) {
      if (parseFloat(item) > 37.5) {
        this.imglist_pm25 = this.color_condi.lv5;
      } else if (parseFloat(item) <= 37.5) {
        this.imglist_pm25 = this.color_condi.lv2;
      }
      // if (parseFloat(item) > 90) {
      //   this.imglist_pm25 = this.color_condi.lv5;
      // } else if (parseFloat(item) <= 90 && parseFloat(item) > 50) {
      //   this.imglist_pm25 = this.color_condi.lv4;
      // } else if (parseFloat(item) <= 50 && parseFloat(item) > 37) {
      //   this.imglist_pm25 = this.color_condi.lv3;
      // } else if (parseFloat(item) <= 37 && parseFloat(item) > 25) {
      //   this.imglist_pm25 = this.color_condi.lv2;
      // } else if (parseFloat(item) <= 25) {
      //   this.imglist_pm25 = this.color_condi.lv1;
      // }
    },
    check_lvtvoc(item) {
      if (parseFloat(item) > 5.5) {
        this.imglist_tvoc = this.color_condi.lv5;
      } else if (parseFloat(item) <= 5.5) {
        this.imglist_tvoc = this.color_condi.lv2;
      }
      // if (parseFloat(item) > 90) {
      //   this.imglist_tvoc = this.color_condi.lv5;
      // } else if (parseFloat(item) <= 90 && parseFloat(item) > 50) {
      //   this.imglist_tvoc = this.color_condi.lv4;
      // } else if (parseFloat(item) <= 50 && parseFloat(item) > 37) {
      //   this.imglist_tvoc = this.color_condi.lv3;
      // } else if (parseFloat(item) <= 37 && parseFloat(item) > 25) {
      //   this.imglist_tvoc = this.color_condi.lv2;
      // } else if (parseFloat(item) <= 25) {
      //   this.imglist_tvoc = this.color_condi.lv1;
      // }
    },
    check_aqi(item) {
      if (parseFloat(item) > 300) {
        this.imglist_aqi = this.color_aqi.lv6;
        // this.imglist_aqi.text = "Hazardous";
      } else if (parseFloat(item) <= 300 && parseFloat(item) > 200) {
        this.imglist_aqi = this.color_aqi.lv5;
        // this.imglist_aqi.text = "Unhealthy";
      } else if (parseFloat(item) <= 200 && parseFloat(item) > 150) {
        this.imglist_aqi = this.color_aqi.lv4;
        // this.imglist_aqi.text = "Literally Unhealthy";
      } else if (parseFloat(item) <= 150 && parseFloat(item) > 100) {
        this.imglist_aqi = this.color_aqi.lv3;
        // this.imglist_aqi.text = "Unhealthy";
      } else if (parseFloat(item) <= 100 && parseFloat(item) > 50) {
        this.imglist_aqi = this.color_aqi.lv2;
        // this.imglist_aqi.text = "Moderate";
      } else if (parseFloat(item) <= 50) {
        this.imglist_aqi = this.color_aqi.lv1;
        // this.imglist_aqi.text = "Good";
      }
    },

    getDateTime() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var hour = now.getHours();
      var minute = now.getMinutes();
      var second = now.getSeconds();
      if (month.toString().length == 1) {
        month = "0" + month;
      }
      if (day.toString().length == 1) {
        day = "0" + day;
      }
      if (hour.toString().length == 1) {
        hour = "0" + hour;
      }
      if (minute.toString().length == 1) {
        minute = "0" + minute;
      }
      if (second.toString().length == 1) {
        second = "0" + second;
      }
      var dateTime =
        day +
        "/" +
        month +
        "/" +
        year +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second;
      return dateTime;
    },
    getWindDirection(d, rt) {
      // rt : Response Type
      let WIND_DIRECTION, WIND_DIRECTION_KEY;
      switch (true) {
        case 0:
        case 360:
          WIND_DIRECTION = "ทิศเหนือ";
          WIND_DIRECTION_KEY = 'N';
          break;
        case 90:
          WIND_DIRECTION = "ทิศตะวันออก";
          WIND_DIRECTION_KEY = 'E';
          break;
        case 180:
          WIND_DIRECTION = "ทิศใต้";
          WIND_DIRECTION_KEY = 'S';
          break;
        case 270:
          WIND_DIRECTION = "ทิศตะวันตก";
          WIND_DIRECTION_KEY = 'W';
          break;
        case d > 0 && d < 90:
          WIND_DIRECTION = "ทิศตะวันออกเฉียงเหนือ";
          WIND_DIRECTION_KEY = 'NE';
          break;
        case d > 90 && d < 180:
          WIND_DIRECTION = "ทิศตะวันออกเฉียงใต้";
          WIND_DIRECTION_KEY = 'SE';
          break;
        case d > 180 && d < 270:
          WIND_DIRECTION = "ทิศตะวันตกเฉียงใต้";
          WIND_DIRECTION_KEY = 'SW';
          break;
        case d > 270 && d < 360:
          WIND_DIRECTION = "ทิศตะวันตกเฉียงเหนือ";
          WIND_DIRECTION_KEY = 'NW';
          break;
        default:
          WIND_DIRECTION = "-";
          WIND_DIRECTION_KEY = "-";
          break;
      }

      return rt === 'short' ? WIND_DIRECTION_KEY : WIND_DIRECTION;
    },
    async callapi() {
      // this.check_lvpm25(this.get_data.pm25);
      // this.check_lvpm10(this.get_data.pm10);
      // this.check_lvtvoc(this.result_value.avgTVCO);
      // this.check_aqi(this.get_data.aqi);

      this.timeout = setTimeout(() => {
        this.callapi();
      }, 10 * 1000);
    },
  },
  async mounted() {
    // await this.getData();
    this.$WSS.connect("yamaha-aqi");
    this.$WSS.emit("yamaha-aqi", "message");
    this.$WSS.on("connect", () => {
      console.log("socket id", this.$WSS.socket().id);
    });
    this.$WSS.on("yamaha-aqi", (messageNew) => {
      console.log("messageNew", messageNew, this.$moment().format("HH:mm:ss"));
      this.result_value = messageNew.message;
      this.wind_direction = this.getWindDirection(
        this.result_value["48FFFF661CD6"].wind_direction
      );
      this.check_lvpm25(this.result_value.air_polution.pm25);
      this.check_lvpm10(this.result_value.air_polution.pm10 / 1000);
      this.check_lvtvoc(this.result_value.avgTVCO);
      this.check_aqi(this.result_value.aqi);

      // Wind Rose
      // console.log(this.dataChartWindRose_2.series);
      // console.log(this.result_value.graph.WindRose);

      // for (
      //   let index = 0;
      //   index < this.dataChartWindRose_2.series.length;
      //   index++
      // ) {
      //   const el = this.dataChartWindRose_2.series[index];

      //   if (this.result_value.graph && this.result_value.graph.length > 0) {
      //     for (let j = 0; j < this.result_value.graph.WindRose.length; j++) {
      //       const el_j = this.result_value.graph.WindRose[j];
      //       if (el.name == el_j.name) {
      //         el.data = el_j.data;
      //       }
      //     }
      //   }
      // }
      // this.dataChartWindRose = this.result_value.graph.WindRose;
      if (this.result_value.graph && this.result_value.graph.WindRose && this.result_value.graph.WindRose.length > 0) {
        this.dataChartWindRose_2.series = this.result_value.graph.WindRose
      } else {
        // let shortText = getWindDirection(this.result_value["48FFFF661CD6"].wind_direction, 'short');
        console.log('[48FFFF661CD6]', this.result_value["48FFFF661CD6"])
      }

      // this.createChart();
      this.selectDataGraph(this.selectData);
    });

    this.currentTime = moment().format("DD MMM YYYY HH:mm:ss");

    await this.callapi();
    this.interval = setInterval(() => {
      this.currentTime = moment().format("DD MMM YYYY HH:mm:ss");
    }, 1000);

    // this.createChart();
  },
  beforeDestroy() {
    this.$WSS.disconnect();
    clearInterval(this.interval);
    clearTimeout(this.timeout);
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Charm:wght@700&family=Kodchasan:wght@500&display=swap");
@import "./aqi.scss";

.container-aqi {
  display: grid;
  grid-template-columns: calc(50% - 10px) calc(50% - 10px);
  grid-template-rows: calc(8% - 10px) calc(46% - 10px) calc(46% - 10px);
  gap: 10px 10px;
  height: 100%;
  justify-content: space-evenly;
  grid-auto-flow: row;
  // background: rgb(91, 155, 213);
  background: linear-gradient(rgba(255, 255, 255, 1), rgba(91, 155, 213, 1));
  //  background-image: linear-gradient(red, yellow);
  grid-template-areas:
    "grid-header grid-header"
    "grid-map grid-aqi-quality"
    "grid-realtime grid-airpollution";
}

// .imgbg {
//   margin: -15px;
//   background-image: url("../../../../assets/images/yamahaaqi/bgdash.png");
//   background-position: center center;
//   background-repeat: no-repeat;
//   background-attachment: fixed;
//   background-size: cover;
//   // height: 100vh;

//   color: #000;
// }
.text-center {
  display: grid;
  align-items: center;
}

.centerHeader {
  text-align: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 5px;
}

.carddiv {
  height: auto;
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 20px;
  display: block;
  //   -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  //   -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.grid-header {
  grid-area: grid-header;
}

.grid-map {
  grid-area: grid-map;
}

.grid-aqi-quality {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: calc(70% - 5px) calc(30% - 5px);
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "item-aqi-quality"
    "item-aqi-level";
  grid-area: grid-aqi-quality;
}

.item-aqi-quality {
  grid-area: item-aqi-quality;
}

.item-aqi-level {
  grid-area: item-aqi-level;
}

.grid-realtime {
  display: grid;
  grid-template-columns: calc(50% - 10px) auto;
  grid-template-rows: calc(15% - 10px) calc(42.5% - 10px) calc(42.5% - 10px);
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "item-header-realtime item-header-realtime"
    "item-realtime-1 item-realtime-2"
    "item-realtime-3 item-realtime-4";
  grid-area: grid-realtime;
}

.item-header-realtime {
  grid-area: item-header-realtime;
}

.item-realtime-1 {
  grid-area: item-realtime-1;
}

.item-realtime-2 {
  grid-area: item-realtime-2;
}

.item-realtime-3 {
  grid-area: item-realtime-3;
}

.item-realtime-4 {
  grid-area: item-realtime-4;
}

.grid-airpollution {
  display: grid;
  grid-template-columns:
    calc(33.33333333333333%) calc(33.33333333333333% - 10px) calc(33.33333333333333% - 10px);
  grid-template-rows: calc(15% - 10px) calc(70% - 10px) calc(15% - 10px);
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "item-header-polution item-header-polution item-header-polution"
    "item-polu-1 item-polu-2 item-polu-3"
    "item-polu-level item-polu-level item-polu-level";
  grid-area: grid-airpollution;
}

.item-header-polution {
  grid-area: item-header-polution;
}

.item-polu-level {
  grid-area: item-polu-level;
}

.item-polu-1 {
  grid-area: item-polu-1;
}

.item-polu-2 {
  grid-area: item-polu-2;
}

.item-polu-3 {
  grid-area: item-polu-3;
}

.list-map-div {
  list-style: none;
  position: absolute;
  bottom: 0px;
  right: 10px;
  font-size: 0.7rem;
  -webkit-text-size-adjust: none;
}

@media screen and (max-width: 1180px) {
  .container-aqi {
    grid-template-columns: auto auto;
    grid-template-rows: auto auto auto auto auto;
    grid-auto-flow: column;
    grid-template-areas:
      "grid-header  grid-header"
      "grid-aqi-quality grid-aqi-quality"
      "grid-realtime grid-realtime"
      "grid-airpollution grid-airpollution"
      "grid-map grid-map";
  }

  .grid-airpollution {
    grid-template-rows: 60px 270px 60px;
    grid-auto-flow: column;
    grid-template-areas:
      "item-header-polution item-header-polution item-header-polution"
      "item-polu-1 item-polu-2 item-polu-3"
      "item-polu-level item-polu-level item-polu-level";
  }

  .grid-realtime {
    grid-template-rows: auto auto auto;
    grid-auto-flow: row;
    grid-template-areas:
      "item-header-realtime item-header-realtime"
      "item-realtime-1 item-realtime-2"
      "item-realtime-3 item-realtime-4";
  }

  .grid-aqi-quality {
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    grid-auto-flow: row;
    grid-template-areas:
      "item-aqi-quality"
      "item-aqi-level";
  }
}

@media only screen and (max-width: 767px) {
  .grid-airpollution {
    grid-template-rows: 60px 170px 60px;

    grid-auto-flow: column;
    grid-template-areas:
      "item-header-polution item-header-polution item-header-polution"
      "item-polu-1 item-polu-2 item-polu-3"
      "item-polu-level item-polu-level item-polu-level";
  }
}
</style>
